import { signal } from 'services/SignalsService'
import { reelsSettings } from 'settings/custom/reels'
import { log } from 'utils/Logger'

export function makeSymbolsService(idx) {
  const spinModel = game.models.SpinModel.get()

  let template
  let queue

  signal.on('FREESPINS-MODE', (value) => change(value))

  function change(isFS) {
    let action = game.models.SpinModel.get().action

    if(action === 'freebet'){
      action = 'spin'
    }
    if(reelsSettings.hasOwnProperty('reelsSet') && reelsSettings.reelsSet){
      log(`REELS SET : ${action} `, 'WARNING')
      template = spinModel.bonusReels[action].length ? spinModel.bonusReels[action] : spinModel.reels
    }
    else{
      template = isFS && spinModel.fsReels.length ? spinModel.fsReels : spinModel.reels
    }

    template = template[idx]
    queue = template.slice()
  }

  function get() {
    if (queue.length === 0) {
      queue = template.slice()
    }
    return queue.shift()
  }

  return { get }
}
